export const business = {
  name: '3D Cleaning Services',
  phone: '+1 (832) 719-7399',
  phoneHref: 'tel:+18327197399',
  whatsappHref: 'https://wa.me/18327197399',
  email: '3dcleaningservices@gmail.com',
  emailHref: 'mailto:3dcleaningservices@gmail.com',
  website: 'www.3dcleaningservices.com',
  city: 'Houston, Texas',
  mapEmbed:
    'https://www.google.com/maps?q=Houston,+Texas&z=10&output=embed',
  social: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
  },
} as const

export const contacts = [
  {
    id: 'nany',
    name: 'Nany',
    phone: '+1 (832) 719-7399',
    phoneHref: 'tel:+18327197399',
    whatsappHref: 'https://wa.me/18327197399',
  },
  {
    id: 'judith',
    name: 'Judith',
    phone: '+1 (713) 497-6411',
    phoneHref: 'tel:+17134976411',
    whatsappHref: 'https://wa.me/17134976411',
  },
] as const

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/soCVRMu8s2LTbTkoi6LWTy/Logo_3d_cleaning_transparente.png',
  hero: 'https://cdn.magicpatterns.com/uploads/kieUQUXGKgJLgi1nGZgq1t/Banner_judith2.png',
  mascot:
    'https://cdn.magicpatterns.com/patterns/generated-images/4c89ce2a-3009-4846-bdc7-e7eec3385f0f.jpg',
  team: 'https://cdn.magicpatterns.com/patterns/generated-images/5be419cc-ab84-43a5-a46f-91874012fd07.jpg',
} as const
